import React from "react";
import PlayerPublicProfile from "../modules/player-profile";

type Props = {};

const PublicProfile = (props: Props) => {
  return <PlayerPublicProfile />;
};

export default PublicProfile;
